import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/settings")({
  loader: () => ({ crumb: "Settings" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
